import styled from '@emotion/styled'

type InputFieldPropsType = {
	label?: string | React.ReactNode
	children: React.ReactNode
}

const InputField = ({ label, children }: InputFieldPropsType) => {
	return (
		<Block>
			{label ? <Label>{label}</Label> : null}
			<InputBlock>{children}</InputBlock>
		</Block>
	)
}

const Block = styled.div`
	display: flex;
	flex-direction: column;
	& + & {
		margin-top: 3.2rem;
	}
`

const Label = styled.label`
	color: #000;
	font-family: Pretendard;
	font-size: 1.5rem;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	letter-spacing: 0.2px;
	margin-bottom: 1.3rem;
`

const InputBlock = styled.div`
	width: 41.2rem;
`

export default InputField
